
import { CodeListMainItems } from "../code-list-main-items.entity";
import { CodeListMain } from "../code-list-main.entity";
import { CodeListMainItemsDTO } from "./code-list-main-items.dto";
import { CodeListMainDTO } from "./code-list-main.dto";

export class CodeListMainAdapter {
    public convertDtoToEntity(dto: CodeListMainDTO): CodeListMain {
        try {
            console.log(dto)
            const entity = new CodeListMain;
            entity.saleOrderId = dto.saleOrderId
            entity.totalCartons = dto.totalCartons
            entity.issuedBy = dto.issuedBy
            entity.verifiedBy = dto.verifiedBy
            entity.isActive = true;
            entity.remarks = dto.remarks
            if (dto?.codeListMainId) {
                entity.codeListMainId = dto.codeListMainId;
                entity.updatedUser = dto.createdUser;
            } else {
                entity.createdUser = dto.createdUser;
            }
            const codeListItems: CodeListMainItems[] = [];            
            for (const sampleDto of dto.codeListItems) {
               const CodeListMainSample = new CodeListMainItems();
                    CodeListMainSample.codeListMainId = dto?.codeListMainId;
                    CodeListMainSample.code = sampleDto?.code;
                    CodeListMainSample.tracebilityCodeId = sampleDto?.tracebilityCodeId;
                    CodeListMainSample.cartons = sampleDto?.cartons;
                    CodeListMainSample.soItemId = sampleDto?.soItemId;
                    CodeListMainSample.productionDate = sampleDto?.productionDate;
                    CodeListMainSample.bestBeforeDate = sampleDto?.bestBeforeDate;
                    CodeListMainSample.unitId = sampleDto?.unitId
                    if (sampleDto?.codeListMainItemId) {
                        CodeListMainSample.codeListMainItemId = sampleDto.codeListMainItemId;
                        CodeListMainSample.updatedUser = dto.createdUser;
                        CodeListMainSample.createdUser = dto.createdUser;
                    } else {
                        CodeListMainSample.createdUser = dto.createdUser;

                    }
                    codeListItems.push(CodeListMainSample);
                
            }
            entity.codeListItems = codeListItems;
            console.log(entity);
            return entity;
        } catch (error) {
            return error
        }

    }

    public convertEntityToDto(obj: CodeListMain): CodeListMainDTO {
        const dto = new CodeListMainDTO;
        dto.codeListMainId = obj.codeListMainId;
        dto.saleOrderId = obj.saleOrderId;
        dto.totalCartons = obj.totalCartons;
        dto.issuedBy = obj.issuedBy;
        dto.verifiedBy = obj.verifiedBy;
       dto.isActive = obj.isActive;
        dto.createdAt = obj.createdAt;
        dto.updatedAt = obj.updatedAt;
        dto.createdUser = obj.createdUser;
        dto.updatedUser = obj.updatedUser;
        dto.versionFlag = obj.versionFlag;
        return dto;
    }

    public convertEntityToLabelDto(obj: CodeListMain): CodeListMainDTO {
        const dto = new CodeListMainDTO;
        dto.codeListMainId = obj.codeListMainId;
        dto.saleOrderId = obj.saleOrderId;
        dto.totalCartons = obj.totalCartons;
        dto.issuedBy = obj.issuedBy;
        dto.verifiedBy = obj.verifiedBy;
       dto.isActive = obj.isActive;
        dto.createdAt = obj.createdAt;
        dto.updatedAt = obj.updatedAt;
        dto.createdUser = obj.createdUser;
        dto.updatedUser = obj.updatedUser;
        dto.versionFlag = obj.versionFlag;
        const codeListItems: CodeListMainItemsDTO[] = [];
        for (const iterator of obj.codeListItems) {
            const CodeListMainSample = new CodeListMainItemsDTO();
            CodeListMainSample.codeListMainId = iterator?.codeListMainId;
            CodeListMainSample.code = iterator?.code;
            CodeListMainSample.tracebilityCodeId = iterator?.tracebilityCodeId;
            CodeListMainSample.cartons = iterator?.cartons;
            CodeListMainSample.productionDate = iterator?.productionDate;
            CodeListMainSample.bestBeforeDate = iterator?.bestBeforeDate;
            CodeListMainSample.codeListMainItemId = iterator.codeListMainItemId;
            codeListItems.push(CodeListMainSample);
        }
        dto.codeListItems = codeListItems;
        return dto;
    }
}
